import {BackendAPIBlueprint} from "../generated/blueprint.ts";
import {getBackendApiBasePath} from "../lib/backendApiBaseUrl.ts";

export class UnauthenticatedBackendApi extends BackendAPIBlueprint {
    private readonly basePath: string;

    constructor() {
        super();
        this.basePath = getBackendApiBasePath();
    }

    public async get(path: string, queryParams: object | null = null, signal?: AbortSignal) {
        let uri = this.basePath + path

        if (queryParams) {
            //@ts-ignore
            uri = uri + "?" + (new URLSearchParams(queryParams).toString());
        }

        return await fetch(uri, {signal});
    }

    public async post(path: string, body: Object, signal?: AbortSignal): Promise<Response> {
        const request = new Request(this.basePath + path, {
            method: "POST",
            body: JSON.stringify(body),
        });

        return fetch(request, {
            headers: {
                "content-type": "application/json"
            },
            signal,
        });
    }
}
